// React imports
import React, { useEffect, useState } from 'react';

// Third-party imports
import { useAuth } from 'react-oidc-context';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { fetchProjectByEmail } from 'src/redux/features/projects/projectsSlice';
import { Select } from 'antd';
import en from 'src/messages/en.json';
import { setError } from 'src/redux/features/common/commonSlice';

export const AssignedProjectsAutoComplete = ({
  onSelectedProjectChange,
  style,
  selectedProject,
  selectedTargetProjectId,
}: {
  onSelectedProjectChange: any;
  style: any;
  selectedProject?: any;
  selectedTargetProjectId?: number | undefined;
}) => {
  const [data, setData] = useState([]);
  const auth = useAuth();
  const dispatch = useDispatch();

  const fetchProjects = async () => {
    try {
      const response = await dispatch(
        fetchProjectByEmail({
          ITProjectLeaderEmail: auth.user.profile.email,
        }),
      ).unwrap();

      const transformedProjects = response.map((proj: any) => ({
        id: proj.projectId,
        name: proj.projectName,
        programManagers: proj.programManagers,
      }));

      setData(transformedProjects);
    } catch (error) {
      dispatch(setError(en.Common.Error.fetchData));
    }
  };

  const filteredProjects = selectedProject
    ? data.filter((val) => val.name != selectedProject)
    : data;

  const projectOptions = filteredProjects.map((proj) => ({
    label: proj.name,
    value: proj.id,
  }));
  const handleChange = (projectId: number) => {
    const selected = data.find((proj) => proj.id === projectId);

    onSelectedProjectChange(selected);
  };

  useEffect(() => {
    fetchProjects();
  }, [dispatch]);

  return (
    <Select
      showSearch
      id="filtering-example2"
      options={projectOptions}
      key="name"
      placeholder={en.Common.Placeholder.default}
      onChange={handleChange}
      style={style}
      showArrow={true}
      allowClear
      value={selectedTargetProjectId ?? undefined}
      filterOption={(input, option) =>
        option?.label?.toString().toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};
